import {
  Box,
  MenuItem,
  Select,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import { useAgentSessions } from "contexts/AgentSessions";
import { useLocation, useNavigate } from "react-router-dom";
import { routes } from "schemas/routes";
import theme from "styles/theme";

import { trackEvent } from "utils/tracking";

const styles = {
  noBorder: {
    fontSize: 12,
    boxShadow: "none",
    ".MuiOutlinedInput-notchedOutline": { border: 0 },
    "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      border: 0,
    },
    "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: 0,
    },
  },
  option: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    maxWidth: { xs: 240, md: 500 },
    color: "primary.main",
    fontSize: 14,
  },
  newIcon: {
    color: grey[500],
    ml: 0.5,
  },
  newChat: {
    color: grey[500],
  },
};

export default function ChatHistory() {
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const location = useLocation();
  const { agentSessions, selectedAgentSessionId } = useAgentSessions();

  const handleChange = (event: any) => {
    const value = event.target.value;

    trackEvent("Chat History Option Selected", {
      Option: value,
    });

    if (value === "new") {
      navigate(`/${routes.home}${location.search}`);
    } else {
      navigate(`/${routes.home}/${value}${location.search}`);
    }
  };

  if (!agentSessions) {
    return <></>;
  }

  return (
    <Box display="flex" alignItems="center" gap={1}>
      {!isMobileScreen && (
        <Box>
          <Typography>Chat History</Typography>
        </Box>
      )}
      <Select
        onChange={handleChange}
        value={selectedAgentSessionId || "new"}
        size="small"
      >
        <MenuItem value="new">
          <em>
            <Box component="span" sx={styles.newChat}>
              New Chat
            </Box>{" "}
            <Box
              className="fa-solid fa-plus"
              component="span"
              sx={styles.newIcon}
            />
          </em>
        </MenuItem>
        {agentSessions.map((session) => (
          <MenuItem key={session.id} value={session.id}>
            <Box sx={styles.option}>{session.name}</Box>
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
}
